import { j as l } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as a } from "react";
import { I as e } from "../../../../IconBase-CxZyIWw2.js";
const i = a((s, c) => /* @__PURE__ */ l.jsx(
  e,
  {
    ref: c,
    ...s,
    image: (r) => /* @__PURE__ */ l.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...r,
        children: [
          /* @__PURE__ */ l.jsxs("g", { clipPath: "url(#clip0_2974_4142)", children: [
            /* @__PURE__ */ l.jsx(
              "mask",
              {
                id: "mask0_2974_4142",
                width: 32,
                height: 32,
                x: 8,
                y: 8,
                maskUnits: "userSpaceOnUse",
                style: {
                  maskType: "alpha"
                },
                children: /* @__PURE__ */ l.jsx(
                  "path",
                  {
                    fill: "currentColor",
                    d: "m23.18 14.34-2.45-2.45a.754.754 0 0 0-1.06 0c-.29.29-.29.77 0 1.06l1.92 1.92-6.61 6.63-1.39-1.4 4.71-4.72c.29-.29.29-.76 0-1.06 0 0-4.74-4.83-5.19-5.28-.5-.5-1.4-1.04-2.4-1.04-.7 0-1.34.27-1.84.77-.92.92-.94 1.88-.81 2.52.18.85.72 1.49 1.03 1.79l3.14 3.14 1.06-1.06-3.14-3.14c-.15-.15-.52-.55-.62-1.04-.09-.42.04-.78.4-1.15q.33-.33.78-.33c.51 0 1.05.31 1.35.61.35.35 3.41 3.47 4.66 4.74L12 19.57c-.29.29-.29.77 0 1.06l2.45 2.45a.75.75 0 0 0 1.06 0l7.67-7.68c.29-.29.29-.76 0-1.06M39.78 37.45c-1.12-1.12-1.09-3.03-1.09-3.04a.7.7 0 0 0-.22-.55L23.26 18.63a.754.754 0 0 0-1.06 0c-.29.29-.29.77 0 1.06l15 15.01c.03.64.2 2.05 1.04 3.23l-.3.3c-1.19-.84-2.59-1.01-3.23-1.04l-15.2-15.22a.754.754 0 0 0-1.06 0c-.29.29-.29.77 0 1.06l15.41 15.43c.15.15.35.24.56.22.02 0 1.9-.04 3.03 1.09a.75.75 0 0 0 1.07.01l1.26-1.26c.29-.3.29-.77 0-1.07"
                  }
                )
              }
            ),
            /* @__PURE__ */ l.jsx("g", { mask: "url(#mask0_2974_4142)", children: /* @__PURE__ */ l.jsx("path", { fill: "currentColor", d: "M0 0h48v48H0z" }) })
          ] }),
          /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "clip0_2974_4142", children: /* @__PURE__ */ l.jsx("path", { fill: "#fff", d: "M0 0h48v48H0z" }) }) })
        ]
      }
    )
  }
));
i.displayName = "AgencyDropperIcon";
export {
  i as AgencyDropperIcon,
  i as default
};
//# sourceMappingURL=index.js.map
